import AutoAwesomeMosaicOutlinedIcon from '@mui/icons-material/AutoAwesomeMosaicOutlined';
import { Stack, Typography } from '@mui/material';
import { _ } from '/@/locale';
import CreateGrowerSection from '/@/views/dashboard/rv/components/create-grower-section';
import { EMPTY_SECTION_SX } from './constants';

export function MyFieldsEmptyState({ onAddFields, onAddField }: { onAddFields: () => void; onAddField: () => void }) {
    return (
        <CreateGrowerSection
            onAddFields={onAddFields}
            onButtonClick={onAddField}
            title={_('Agregá lotes para generar recomendaciones')}
            subtitle={_('Vas a poder generar recomendaciones personalizadas según las condiciones del lote.')}
            buttonLabel={_('Agregar lote')}
            icon={<AutoAwesomeMosaicOutlinedIcon sx={{ width: 36, height: 36, mb: 1 }} color='primary' />}
            sx={EMPTY_SECTION_SX}
        />
    );
}

export function NoGrowersEmptyState({
    onAddFields,
    onOpenGrowersModal,
}: {
    onAddFields: () => void;
    onOpenGrowersModal: () => void;
}) {
    return (
        <CreateGrowerSection
            onAddFields={onAddFields}
            onOpenModal={onOpenGrowersModal}
            title={_('Agregá un productor para empezar a recomendar')}
            subtitle={_('Vas a poder generar recomendaciones personalizadas para sus lotes.')}
            sx={EMPTY_SECTION_SX}
            singleGrower
        />
    );
}

/**
 * Shown when a hybrid is fixed and none of the user's fields lie in its zones.
 *
 * Distinct from the "no fields" states below: the fields exist, they just aren't where this
 * hybrid is sold. Offering "Agregar lote" here would be the wrong advice — the way out is a
 * different hybrid, so this state deliberately has no action.
 */
export function NoFieldsForProductEmptyState({ productName }: { productName?: string }) {
    return (
        <Stack alignItems='center' justifyContent='center' spacing={1} sx={{ ...EMPTY_SECTION_SX, width: '100%' }}>
            <AutoAwesomeMosaicOutlinedIcon sx={{ width: 36, height: 36, mb: 1 }} color='primary' />
            <Typography variant='subtitle1' color='primary' fontWeight='bold' textAlign='center'>
                {productName
                    ? _('Ninguno de tus lotes está en la zona de {{product}}', { product: productName })
                    : _('Ninguno de tus lotes está en la zona del híbrido elegido')}
            </Typography>
            <Typography variant='body2' color='primary.mui.inactive' textAlign='center'>
                {_('Este híbrido se recomienda para otras zonas. Probá con otro híbrido para estos lotes.')}
            </Typography>
        </Stack>
    );
}

export function GrowerHasNoFieldsEmptyState({
    onAddFields,
    onAddField,
}: {
    onAddFields: () => void;
    onAddField: () => void;
}) {
    return (
        <CreateGrowerSection
            onAddFields={onAddFields}
            onButtonClick={onAddField}
            title={_('Este productor aún no tiene lotes agregados')}
            subtitle={_('Cuando se carguen, vas a poder hacer el seguimiento desde esta pantalla.')}
            buttonLabel={_('Agregar lote')}
            icon={<AutoAwesomeMosaicOutlinedIcon sx={{ width: 36, height: 36, mb: 1 }} color='primary' />}
            sx={{ ...EMPTY_SECTION_SX, width: '100%' }}
        />
    );
}
